export const UpArrowSVG = ({ width = '25', height = '16', fillColor = '#FF5252' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: 'baseline' }}
  >
    <path
      d="M1 17.5C0.723858 17.5 0.5 17.7239 0.5 18C0.5 18.2761 0.723858 18.5 1 18.5L1 17.5ZM26.3536 0.646447C26.1583 0.451184 25.8417 0.451184 25.6464 0.646447L22.4645 3.82843C22.2692 4.02369 22.2692 4.34027 22.4645 4.53553C22.6597 4.7308 22.9763 4.7308 23.1716 4.53553L26 1.70711L28.8284 4.53553C29.0237 4.7308 29.3403 4.7308 29.5355 4.53553C29.7308 4.34027 29.7308 4.02369 29.5355 3.82843L26.3536 0.646447ZM1 18.5C4.06489 18.5 7.19304 18.5628 10.1353 18.374C13.0798 18.185 15.8845 17.7423 18.315 16.7102C20.7572 15.6732 22.8185 14.0422 24.2611 11.4965C25.6983 8.96044 26.5 5.55479 26.5 1L25.5 1C25.5 5.44521 24.7166 8.66456 23.3911 11.0035C22.071 13.3328 20.1921 14.8268 17.9241 15.7898C15.6445 16.7577 12.9692 17.19 10.0712 17.376C7.1711 17.5622 4.09453 17.5 1 17.5L1 18.5Z"
      fill={fillColor}
    />
  </svg>
);
export const ArrowBackIosNewOutlinedSVG = ({ width = '16', height = '16', fillColor = '#5F6178' }) => (
  <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3467 2.5135L11.1667 1.3335L4.5 8.00016L11.1667 14.6668L12.3467 13.4868L6.86 8.00016L12.3467 2.5135Z"
      fill={fillColor}
    />
  </svg>
);
export const PromotedPlanSVG = ({ width = '32', height = '47', fillColor = '#852CFF' }) => (
  <svg width={width} height={height} viewBox="0 0 32 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0H32V44.3915C32 45.9624 30.2721 46.9201 28.94 46.0875L17.06 38.6625C16.4115 38.2572 15.5885 38.2572 14.94 38.6625L3.06 46.0875C1.7279 46.9201 0 45.9624 0 44.3915V0Z"
      fill={fillColor}
    />
    <path
      d="M16.0003 22.3915L21.1503 25.4998L19.7837 19.6415L24.3337 15.6998L18.342 15.1915L16.0003 9.6665L13.6587 15.1915L7.66699 15.6998L12.217 19.6415L10.8503 25.4998L16.0003 22.3915Z"
      fill="white"
    />
  </svg>
);

export const CheckCircledSvg = ({ width = '20', height = '20', fillColor = 'none', strokeColor = '#41B568' }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z"
      stroke={strokeColor}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3332 8.33301L9.1665 12.4997L6.6665 9.99967"
      stroke={strokeColor}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const InfoOutlinedSvg_New = ({ width = '14', height = '15', fillColor = 'none', strokeColor = '#8126FF' }) => (
  <svg width={width} height={height} viewBox="0 0 14 15" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33301 4.16683H7.66634V5.50016H6.33301V4.16683ZM6.33301 6.8335H7.66634V10.8335H6.33301V6.8335ZM6.99967 0.833496C3.31967 0.833496 0.333008 3.82016 0.333008 7.50016C0.333008 11.1802 3.31967 14.1668 6.99967 14.1668C10.6797 14.1668 13.6663 11.1802 13.6663 7.50016C13.6663 3.82016 10.6797 0.833496 6.99967 0.833496ZM6.99967 12.8335C4.05967 12.8335 1.66634 10.4402 1.66634 7.50016C1.66634 4.56016 4.05967 2.16683 6.99967 2.16683C9.93967 2.16683 12.333 4.56016 12.333 7.50016C12.333 10.4402 9.93967 12.8335 6.99967 12.8335Z"
      fill={strokeColor}
      strokeWidth="0.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckmarkSVGIcon = ({ color = '#5939A2' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.598 1.08157L4.43797 7.99157L2.53797 5.96157C2.18797 5.63157 1.63797 5.61157 1.23797 5.89157C0.847968 6.18157 0.737968 6.69157 0.977968 7.10156L3.22797 10.7616C3.44797 11.1016 3.82797 11.3116 4.25797 11.3116C4.66797 11.3116 5.05797 11.1016 5.27797 10.7616C5.63797 10.2916 12.508 2.10157 12.508 2.10157C13.408 1.18157 12.318 0.371566 11.598 1.07157V1.08157Z"
      fill={color}
    />
  </svg>
);
export const SmallCopyIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.5 15.25C5.5335 15.25 4.75 14.4665 4.75 13.5V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H13.5C14.4665 4.75 15.25 5.5335 15.25 6.5M10.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V10.75C19.25 9.64543 18.3546 8.75 17.25 8.75H10.75C9.64543 8.75 8.75 9.64543 8.75 10.75V17.25C8.75 18.3546 9.64543 19.25 10.75 19.25Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotesSVGIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 42V42C40.21 42 42 40.21 42 38V26C42 24.896 41.104 24 40 24H34V38C34 40.21 35.79 42 38 42Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14 16H26" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 23.74H26" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 32.12H20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M34 24V10C34 8.896 33.104 8 32 8L8 8C6.896 8 6 8.896 6 10L6 38C6 40.21 7.79 42 10 42H38"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SearchThinSVGIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      d="M39.9999 40L32.7524 32.7526"
      stroke="#EBEBEB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 22C8 29.732 14.268 36 22 36C29.732 36 36 29.732 36 22C36 14.268 29.732 8 22 8V8C14.2682 8.00057 8.00057 14.2682 8 22"
      stroke="#EBEBEB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ApiSubscriptionsThumbSVGIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="300" height="175" viewBox="0 0 300 175" fill="none">
    <path d="M299.264 0H0.00390625V175H299.264V0Z" fill="#DEDEDE" />
  </svg>
);
